import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { Config } from '../../config';

@Component({
  selector: 'vrm-grid-short-trip-flag',
  template: `
    <div *ngIf="value" class="center">
      <img [src]="flag" width="20" height="20" />
    </div>
  `,
  styles: [
    `
      .center {
        text-align: center;
      }
    `,
  ],
})
export class GridShortTripFlagComponent implements ICellRendererAngularComp {
  public value: number;
  public flag: string;

  constructor() {}

  agInit(params: { value: any }) {
    this.value = params.value;
    this.flag = `${Config.assetCdnRoot}images/short-trip.png`;
  }

  refresh() {
    return false;
  }
}
